import { useQuery } from '@tanstack/react-query'

import { toast } from '@/components/ui'
import { projectService } from '@/services/http/projectService'

type GetPortfolioTagsParams = {
  portfolioId: string
  enabled?: boolean
}

export function useGetPortfolioTags({
  portfolioId,
  enabled = true,
}: GetPortfolioTagsParams) {
  const { data, isLoading, refetch, isError } = useQuery({
    queryKey: ['portfolioTags', portfolioId],
    queryFn: () => projectService.portfolio.getPortfolioTags({ portfolioId }),
    enabled,
  })

  if (isError) {
    toast({
      title: 'Erro ao buscar tags do portfolio',
      variant: 'destructive',
    })
  }

  if (data) {
    return {
      tags: data,
      isLoading,
      isError,
      refetchTags: refetch,
    }
  }

  return {
    tags: [],
    isLoading,
    isError,
    refetchTags: refetch,
  }
}
